import React, { lazy, Suspense, useEffect } from 'react'
import { isChrome } from 'react-device-detect'
import { Redirect, Route } from 'react-router-dom'
import { Slide, toast, ToastContainer } from 'react-toastify'
import PageLoader from '../atoms/PageLoader'

// PageComponent
const AccountsSignin = lazy(() => import('../../core/pages/accounts/signin'))
const AccountsResetPassRequest = lazy(() => import('../../core/pages/accounts/reset-pass-request'))
const AccountsResetPassExec = lazy(() => import('../../core/pages/accounts/reset-pass-exec'))
const AccountsChangeEmail = lazy(() => import('../../core/pages/accounts/change-email'))
const AccountsChangePass = lazy(() => import('../../core/pages/accounts/change-pass'))
const AccountsJoin = lazy(() => import('../../core/pages/accounts/join'))

const AppMain: React.FC = () => {
  useEffect(() => {
    if (!isChrome) {
      toast.warn(`推奨ブラウザはChromeのみとなっております`)
    }
  }, [])

  return (
    <>
      <Suspense fallback={PageLoader}>
        <Route path="/signin/:redirectURL?" component={AccountsSignin} />
        <Route exact path="/reset-pass-request" component={AccountsResetPassRequest} />
        <Route exact path="/reset-pass-exec" component={AccountsResetPassExec} />
        <Route exact path="/change-email" component={AccountsChangeEmail} />
        <Route exact path="/change-pass" component={AccountsChangePass} />
        <Route path="/join/:token" component={AccountsJoin} />
      </Suspense>

      {/* Default */}
      <Route exact path="/" render={() => <Redirect to="/signin" />} />

      <ToastContainer hideProgressBar={true} position={toast.POSITION.BOTTOM_LEFT} transition={Slide} />
    </>
  )
}

export default AppMain
